import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Grid, Form } from 'semantic-ui-react';

import SelectSitesTable from 'Common/SelectSitesTableReduxForm';
import { GACashIncomeFieldEnum as Fields } from 'Common/FieldEnum';
import { GA_CASH_INCOME_FORM_NAME } from 'Common/FormEnum';
import { RangeDatePickerField } from 'Common/SemanticWrapper';
import { rangeDateValidator } from 'Common/FormHelper';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import { TitledCard } from 'Components';

function GACashIncomeFormContainer() {
  return (
    <Form name="GACashIncomeForm">
      <TitledCard title={'Report Parameters'}>
        <Grid>
          <Grid.Row>
            <Grid.Column width={8}>
              <RangeDatePickerField
                fromName={Fields.FromDate}
                toName={Fields.ToDate}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </TitledCard>
      <TitledCard title={'Select Sites'}>
        <Grid>
          <Grid.Row>
            <Grid.Column>
              <Field name={Fields.Sites} component={SelectSitesTable} />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </TitledCard>
    </Form>
  );
}

const validate = (values) => {
  const errors = {};

  if (
    !values[Fields.Sites] ||
    (Array.isArray(values[Fields.Sites]) && !values[Fields.Sites].length)
  ) {
    errors[Fields.Sites] = 'At least one site must be selected.';
  }

  const rangeErrors = rangeDateValidator(
    values[Fields.FromDate],
    values[Fields.ToDate],
    {
      granularity: 'day',
      fromName: Fields.FromDate,
      toName: Fields.ToDate,
      fromLabel: 'From',
      toLabel: 'To',
      dateFormat: DATE_FORMAT_FOR_UI,
      strict: false,
      yearLimit: 1,
    }
  );

  return { ...errors, ...rangeErrors };
};

export const GACashIncomeForm = reduxForm({
  validate,
  form: GA_CASH_INCOME_FORM_NAME,
  enableReinitialize: true,
  destroyOnUnmount: false,
})(GACashIncomeFormContainer);



// WEBPACK FOOTER //
// ./src/pages/gacashincome/components/GACashIncomeForm.js